/**
 * @typedef {Object} BackInStockSnippetData
 * @property {BackInStockSnippetDataSelectedVariant | undefined} selectedVariant
 */

/**
 * @typedef {Object} BackInStockSnippetDataSelectedVariant
 * @property {string} sref1
 * @property {string} sref2
 * @property {number} availableQty
 */

const backInStockSnippetData = /** @type {BackInStockSnippetData} */ (
    JSON.parse(
        document.getElementById("back-in-stock-subscription-snippet-data")?.textContent ?? "{}"
    )
);

const backInStockSlidingElement = /** @type {HTMLElement}*/ (document.getElementById("back-in-stock-sliding-element"));
const backInStockGlobalWrapper = /** @type {HTMLElement}*/ (document.getElementById("back-in-stock-wrapper"));
const loaderWrapper = /** @type {HTMLElement}*/ (document.getElementById("back-in-stock-loader-wrapper"));
const backInStockSubscriptionWrapper = /** @type {HTMLElement}*/ (document.getElementById("backInStockSubscriptionWrapper"));

const backInStockBellSvg = /** @type {HTMLElement}*/ (document.getElementById("back-in-stock-bell-svg"));

const sref2OutOfStockSpan = /** @type {HTMLElement}*/ (document.getElementById("sref2OutOfStockSpan"));

const alreadySubscribedWrapper = /** @type {HTMLElement}*/ (document.getElementById("alreadySubscribedWrapper"));
const successSubscribeWrapper = /** @type {HTMLElement}*/ (document.getElementById("successSubscribeWrapper"));
const isInStockWrapper = /** @type {HTMLElement}*/ (document.getElementById("isInStockWrapper"));
const productErrorWrapper = /** @type {HTMLElement}*/ (document.getElementById("productErrorWrapper"));
const apiNotReachableWrapper = /** @type {HTMLElement}*/ (document.getElementById("apiNotReachableWrapper"));

const confirmSubscriptionBtn = /** @type {HTMLButtonElement}*/ (document.getElementById("confirmSubscriptionBtn"));
const subscriptionEmailInput = /** @type {HTMLInputElement}*/ (document.getElementById("subscriptionEmailInput"));
const invalidEmailFormatP = /** @type {HTMLElement}*/ (document.getElementById("invalidEmailFormatP"));
const emailFormWrapper = /** @type {HTMLElement}*/ (document.getElementById("emailFormWrapper"));
const agreeTosCheckboxInput = /** @type {HTMLInputElement}*/ (document.getElementById("agreeTosCheckboxInput"));


const emailsuccessSpan = /** @type {HTMLElement}*/ (document.getElementById("emailsuccessSpan"));
const emailAlreadySubbedSpan = /** @type {HTMLElement}*/ (document.getElementById("emailAlreadySubbedSpan"));

const backInStockSubscriptionWebSubscriptionApi = getDivZeroWebPublicApi(DivZeroWebPublicApi.WebSubscriptionApi, false);

document.addEventListener("DOMContentLoaded", () => {
    if (backInStockSnippetData.selectedVariant) {
        backInStockToggle(backInStockSnippetData.selectedVariant.sref2, backInStockSnippetData.selectedVariant.availableQty, false);
    }
    document.addEventListener("variant:changed", event => backInStockToggle(event.detail.sref2, event.detail.stock));
});

/**
 * Toggle the visibility of the Back in stock snippet depending on if there is stock or not.
 * @param {String} selectedSref2 
 * @param {Number} stockQty 
 * @param {Boolean} scrollToOnBo 
 */
function backInStockToggle(selectedSref2, stockQty, scrollToOnBo = true) {
    sref2OutOfStockSpan.innerText = selectedSref2;
    if (stockQty == 0) {
        if (scrollToOnBo) {
            setTimeout(() => {
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        backInStockSlidingElement.scrollIntoView({ behavior: "smooth", block: "center" });
                        waitUntilInView(backInStockSlidingElement).then(() => {
                            setTimeout(() => ringBell(backInStockBellSvg), 250);
                        });
                    });
                });
            }, 500)
        }

        slidingElementAnimation(backInStockSlidingElement, true);
    }
    else slidingElementAnimation(backInStockSlidingElement, false);
}


function refreshModal() {
    backInStockGlobalWrapper.classList.remove("resultView");

    backInStockSubscriptionWrapper.classList.remove("d-none");

    alreadySubscribedWrapper.classList.add("d-none");
    successSubscribeWrapper.classList.add("d-none");
    isInStockWrapper.classList.add("d-none");
    productErrorWrapper.classList.add("d-none");
    apiNotReachableWrapper.classList.add("d-none");
}

function updateConfirmBtnState() {
    confirmSubscriptionBtn.disabled = !!!subscriptionEmailInput.value || !agreeTosCheckboxInput.checked;
}

/**
 * 
 * @param {Event} event 
 */
async function postSubscription(event) {
    //If format of email is invalid
    if (!(new RegExp(/[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/).test(subscriptionEmailInput.value))) {
        invalidEmailFormatP.classList.remove("invisible");
        //play a shaking animation to indicate that the user needs to enter a valid email
        emailFormWrapper.classList.add("errorShakeAnimation");
        emailFormWrapper.addEventListener("animationend", () => {
            emailFormWrapper.classList.remove("errorShakeAnimation");
        });
    }
    else {
        invalidEmailFormatP.classList.add("invisible");

        //show the loader
        loaderWrapper.classList.add("show");

        try {
            let response = await backInStockSubscriptionWebSubscriptionApi.webSubscriptionCreateWebSubscription({
                websiteId: siteId,
                customerEmail: subscriptionEmailInput.value,
                customerLang: locale,
                divZeroWebApiDomainNswagApiModelsDivZeroWebApiModelsCreateWebSubscriptionRequest: {
                    reference: selectedVariant?.ref,
                    sref1: selectedVariant?.sref1,
                    sref2: selectedVariant?.sref2
                }
            });

            backInStockGlobalWrapper.classList.add("resultView");

            if (response.value)
                setupSubscribeSuccess();
            else if (response.issues?.errors?.some(error => error.issueType == 1))
                setupProductError();
            else if (response.issues?.errors?.some(error => error.issueType == 3))
                setupAlreadySubbed();

            loaderWrapper.classList.remove("show");
            agreeTosCheckboxInput.checked = false;
            confirmSubscriptionBtn.disabled = true;
        }
        catch (error) {
            //Hide the loader again
            setupApiNotReachableWrapper();
            loaderWrapper.classList.remove("show");
            agreeTosCheckboxInput.checked = false;
            confirmSubscriptionBtn.disabled = true;
            console.log(error)
            //ADD ERROR MESSAGE LATER
        }

        loaderWrapper.classList.remove("show");
    }
}

function setupSubscribeSuccess() {
    successSubscribeWrapper.classList.remove("d-none");
    emailsuccessSpan.innerText = subscriptionEmailInput.value;

    backInStockSubscriptionWrapper.classList.add("d-none");
    alreadySubscribedWrapper.classList.add("d-none");
    isInStockWrapper.classList.add("d-none");
    productErrorWrapper.classList.add("d-none");
    apiNotReachableWrapper.classList.add("d-none");
}

function setupAlreadySubbed() {
    alreadySubscribedWrapper.classList.remove("d-none");
    emailAlreadySubbedSpan.innerText = subscriptionEmailInput.value;

    backInStockSubscriptionWrapper.classList.add("d-none");
    successSubscribeWrapper.classList.add("d-none");
    isInStockWrapper.classList.add("d-none");
    productErrorWrapper.classList.add("d-none");
    apiNotReachableWrapper.classList.add("d-none");
}

function setupInStock() {
    isInStockWrapper.classList.remove("d-none");

    backInStockSubscriptionWrapper.classList.add("d-none");
    successSubscribeWrapper.classList.add("d-none");
    alreadySubscribedWrapper.classList.add("d-none");
    productErrorWrapper.classList.add("d-none");
    apiNotReachableWrapper.classList.add("d-none");
}

function setupProductError() {
    productErrorWrapper.classList.remove("d-none");

    backInStockSubscriptionWrapper.classList.add("d-none");
    successSubscribeWrapper.classList.add("d-none");
    alreadySubscribedWrapper.classList.add("d-none");
    isInStockWrapper.classList.add("d-none");
    apiNotReachableWrapper.classList.add("d-none");
}

function setupApiNotReachableWrapper() {
    apiNotReachableWrapper.classList.remove("d-none");

    backInStockSubscriptionWrapper.classList.add("d-none");
    successSubscribeWrapper.classList.add("d-none");
    alreadySubscribedWrapper.classList.add("d-none");
    isInStockWrapper.classList.add("d-none");
    productErrorWrapper.classList.add("d-none");
}

/**
 * 
 * @param {HTMLElement} el 
 * @returns {Promise<void>}
 */
function waitUntilInView(el) {
    return new Promise((resolve) => {
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                observer.disconnect();
                resolve();
            }
            //90% visible
        }, { threshold: 0.9 });
        observer.observe(el);
    });
}

/**
 * 
 * @param {HTMLElement} bellEl 
 */
function ringBell(bellEl) {
    bellEl.classList.remove('bell-shake');
    requestAnimationFrame(() => {
        bellEl.classList.add('bell-shake');
    });
}